const { useState, useEffect } = require("react")

function getOnlineStatus () {
  return typeof navigator !== "undefined" &&
    typeof navigator.onLine === "boolean"
    ? navigator.onLine
    : true
}

function useOnlineStatus () {
  const [onlineStatus, setOnlineStatus] = useState(getOnlineStatus())

  const goOnline = () => setOnlineStatus(true)

  const goOffline = () => setOnlineStatus(false)

  // const timeout = () => setTimeout((alert('hello')), 3000)

  useEffect(() => {
    window.addEventListener("online", goOnline)
    window.addEventListener("offline", goOffline)
  //   const timeout = setTimeout(() => {
  //   window.removeEventListener("online", goOnline)
  // }, 5000);

    return () => {
      window.removeEventListener("online", goOnline)
      window.removeEventListener("offline", goOffline)
    }
  }, [])

  return onlineStatus
}

export default useOnlineStatus
